import { DeviceTypeWithAndroidIOS } from '@/types/configs'
import type { WorldCardLane } from '@/types/viverse-world-card'

export function filterWorldsByDevice<T extends WorldCardLane>(
  allWorlds: T[],
  deviceType: DeviceTypeWithAndroidIOS,
) {
  return allWorlds
    .filter((world) => world.rooms && world.rooms.length > 0)
    .map((world) => {
      const hasWorldLevelDeviceFilter =
        world.is_device_filter_enabled === true &&
        world.preferred_devices &&
        world.preferred_devices.length > 0

      if (hasWorldLevelDeviceFilter) {
        // 🥷🏼 desktop could see all worlds by default
        const shouldInclude = world.preferred_devices!.includes(deviceType)

        const filteredRooms = world.rooms.filter((room) =>
          room?.preferred_devices?.some((device) => world.preferred_devices!.includes(device)),
        )

        const rooms = shouldInclude ? filteredRooms : []

        return {
          shouldInclude,
          world: {
            ...world,
            rooms,
          },
        }
      }

      const rooms = world.rooms.filter((room) => room?.preferred_devices?.includes(deviceType))
      const shouldInclude = rooms.length > 0

      return {
        shouldInclude,
        world: {
          ...world,
          rooms,
        },
      }
    })
    .filter((result) => result.shouldInclude)
    .map((result) => result.world)
}
